import axios from 'axios';
import * as turf from '@turf/turf';

export const haveCreds = (options) => {
    return !!(options.app_id && options.api_key);
};

export const haveAllOptions = (options) => {
    return !!(
        options.app_id &&
        options.api_key &&
        options.travel_time &&
        options.type &&
        options.departure_time
    );
};

export const fetchTravelTimeCredentials = async (token) => {
    const searchParams = new URLSearchParams({
        f: 'json',
        where: '1=1',
        outFields: 'app_id,app_key', // Should be api_key!
        returnGeometry: false,
        token: token,
    });

    const url = `https://gis.london.gov.uk/arcgis/rest/services/apps/hsds_experian_shoppoint/MapServer/7/query?${searchParams}`;

    return await axios
        .get(url)
        .then((res) => {
            // The endpoint returns 200 status even if there is an error ¯\_(ツ)_/¯
            // Must check for presence of 'res.data.error' instead
            if (res.data.error) {
                throw new Error(res.data.error);
            }

            const props = res.data.features[0].attributes;
            return {
                app_id: props.app_id,
                api_key: props.app_key, // NOTE: app_key === api_key
            };
        })
        .catch((e) => {
            console.error(e);
            return {
                app_id: null,
                api_key: null,
            };
        });
};

export const fetchTravelTimeData = (options) => {
    const searchParams = new URLSearchParams(options);
    const url = `https://api.traveltimeapp.com/v4/time-map?${searchParams}`;

    return fetch(url)
        .then((res) => res.json())
        .then(extractResults)
        .then((geojson) => appendFocusPoint(geojson, options.lng, options.lat));
};

const extractResults = (data) => {
    if (!data.results) {
        throw new Error(data.error);
    }
    return data.results.map(shapesToGeojson);
};

const shapesToGeojson = (result) => {
    return {
        type: 'FeatureCollection',
        features: result.shapes.map(shapeToFeature),
    };
};

const shapeToFeature = (shape) => {
    const feature = {
        type: 'Feature',
        properties: {},
        geometry: {
            type: 'Polygon',
            coordinates: [
                ...objectCoordsToArrayCoords(shape.shell),
                ...objectCoordsToArrayCoords(shape.holes),
            ],
        },
    };

    turf.rewind(feature.geometry, { mutate: true });
    return feature;
};

const objectCoordsToArrayCoords = (coords) => {
    if (coords.length === 0) {
        return [];
    }

    return [coords.map((c) => [c.lng, c.lat])];
};

const appendFocusPoint = (geojson, lng, lat) => {
    geojson.forEach((collection) => {
        collection.features.push({
            type: 'Feature',
            geometry: {
                type: 'Point',
                coordinates: [lng, lat],
            },
            properties: {
                focus_point: true,
            },
        });
    });

    return geojson;
};
